export default "__VITE_ASSET__By3O6GrR__"